import { render, staticRenderFns } from "./salesCatalogue.vue?vue&type=template&id=1abdc9bc&scoped=true"
import script from "./salesCatalogue.vue?vue&type=script&lang=js"
export * from "./salesCatalogue.vue?vue&type=script&lang=js"
import style0 from "./salesCatalogue.vue?vue&type=style&index=0&id=1abdc9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abdc9bc",
  null
  
)

export default component.exports